(() => {
  if (window.customFabricsCollectionLoaded) return;
  window.customFabricsCollectionLoaded = true;

  const getColourSchemes = (swatch) =>
    (swatch.dataset.colourSchemes || '')
      .split('|')
      .map((scheme) => scheme.trim())
      .filter(Boolean);

  const selectSwatch = (swatch) => {
    if (!swatch) return;

    const card = swatch.closest('[data-fabric-card]');
    if (!card) return;

    const variantId = swatch.dataset.variantId;
    const variantTitle = swatch.dataset.variantTitle;
    const variantUrl = swatch.dataset.variantUrl;
    const isAvailable = swatch.dataset.variantAvailable === 'true';

    const mainImage = card.querySelector('[data-fabric-image]');
    const colourName = card.querySelector('[data-fabric-colour]');
    const variantInput = card.querySelector('[data-fabric-variant-input]');
    const addButton = card.querySelector('[data-fabric-add-button]');
    const addText = card.querySelector('[data-fabric-add-text]');
    const productLinks = card.querySelectorAll('[data-fabric-product-link]');

    card.querySelectorAll('[data-fabric-swatch]').forEach((item) => {
      const isActive = item === swatch;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (colourName) {
      colourName.textContent = variantTitle;
    }

    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = !isAvailable;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (addButton) {
      const labelTemplate =
        addButton.dataset.addLabel || 'Add product in [colour] to cart';
      const availableLabel = labelTemplate.replace('[colour]', variantTitle);
      const buttonLabel = isAvailable
        ? availableLabel
        : `${variantTitle} is unavailable`;

      addButton.disabled = !isAvailable;
      addButton.setAttribute('aria-label', buttonLabel);

      if (addText) {
        addText.textContent = buttonLabel;
      }
    }

    if (variantUrl) {
      productLinks.forEach((link) => {
        link.href = variantUrl;
      });
    }

    if (mainImage && swatch.dataset.imageSrc) {
      mainImage.src = swatch.dataset.imageSrc;

      if (swatch.dataset.imageSrcset) {
        mainImage.srcset = swatch.dataset.imageSrcset;
      } else {
        mainImage.removeAttribute('srcset');
      }

      if (swatch.dataset.imageAlt) {
        mainImage.alt = swatch.dataset.imageAlt;
      }

      if (swatch.dataset.imageWidth) {
        mainImage.width = swatch.dataset.imageWidth;
      }

      if (swatch.dataset.imageHeight) {
        mainImage.height = swatch.dataset.imageHeight;
      }
    }
  };

  const filterSection = (section, selectedFilter) => {
    const gridItems = section.querySelectorAll('[data-fabric-grid-item]');
    const emptyState = section.querySelector('[data-fabrics-empty]');
    let visibleCount = 0;

    gridItems.forEach((gridItem) => {
      const card = gridItem.querySelector('[data-fabric-card]');
      const swatches = card
        ? Array.from(card.querySelectorAll('[data-fabric-swatch]'))
        : [];
      let targetSwatch = null;

      if (selectedFilter === 'all') {
        const defaultVariantId = card?.dataset.defaultVariantId;

        targetSwatch =
          swatches.find(
            (swatch) => swatch.dataset.variantId === defaultVariantId
          ) || swatches[0];
      } else {
        targetSwatch = swatches.find((swatch) =>
          getColourSchemes(swatch).includes(selectedFilter)
        );
      }

      const shouldShow = selectedFilter === 'all' || Boolean(targetSwatch);

      gridItem.hidden = !shouldShow;

      if (shouldShow) {
        visibleCount += 1;

        if (targetSwatch) {
          selectSwatch(targetSwatch);
        }
      }
    });

    if (emptyState) {
      emptyState.hidden = visibleCount > 0;
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-fabric-swatch]');

    if (swatch) {
      if (!swatch.disabled) {
        selectSwatch(swatch);
      }

      return;
    }

    const filterButton = event.target.closest('[data-fabric-filter]');
    if (!filterButton) return;

    const section = filterButton.closest('[data-custom-fabrics]');
    if (!section) return;

    section.querySelectorAll('[data-fabric-filter]').forEach((button) => {
      const isActive = button === filterButton;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    filterSection(section, filterButton.dataset.fabricFilter);
  });
})();
